<div class="container">
  <!-- TOP BAR: Dropdowns + Toolbar + UI State side by side -->
  <div class="top-bar">
    <div class="top-bar-left">
      <div class="form-group-compact">
        <label class="form-label-compact fw-medium"
          >Facility<span class="text-danger">*</span></label
        >
        <ng-select
          [items]="facilities"
          bindLabel="name"
          bindValue="id"
          placeholder="Select Facility"
          [clearable]="true"
          [searchable]="true"
          class="w-100 rounded"
          [(ngModel)]="selectedFacilityId"
          (change)="onFacilityChange($event)"
        >
        </ng-select>
      </div>

      <div class="form-group-compact">
        <label class="form-label-compact fw-medium"
          >Floor<span class="text-danger">*</span></label
        >
        <ng-select
          [items]="floors"
          bindLabel="name"
          bindValue="id"
          placeholder="Select Floor"
          [clearable]="true"
          [searchable]="true"
          class="w-100 rounded"
          [(ngModel)]="selectedFloorId"
          (change)="onFloorChange($event)"
        >
        </ng-select>
      </div>

      <div class="toolbar-group" *ngIf="floorPlanUrl">
        <button class="btn btn-icon" (click)="zoomIn()" title="Zoom In">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <circle cx="11" cy="11" r="8"></circle>
            <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
            <line x1="11" y1="8" x2="11" y2="14"></line>
            <line x1="8" y1="11" x2="14" y2="11"></line>
          </svg>
        </button>
        <button class="btn btn-icon" (click)="zoomOut()" title="Zoom Out">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <circle cx="11" cy="11" r="8"></circle>
            <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
            <line x1="8" y1="11" x2="14" y2="11"></line>
          </svg>
        </button>
        <button class="btn btn-icon" (click)="resetZoom()" title="Reset Zoom">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <polyline points="1 4 1 10 7 10"></polyline>
            <path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"></path>
          </svg>
        </button>
        <div class="zoom-display">{{ zoom * 100 | number: "1.0-0" }}%</div>
      </div>
    </div>

    <div
      class="overall-ui-banner"
      *ngIf="floorPlanUrl && devices.length"
      [attr.data-sim-version]="simulationDisplayVersion"
      [class.overall-ui-banner--normal]="getOverallUiState() === 'Normal'"
      [class.overall-ui-banner--monitoring]="
        getOverallUiState() === 'Monitoring'
      "
      [class.overall-ui-banner--critical]="getOverallUiState() === 'Critical'"
    >
      <div class="overall-ui-content">
        <div class="overall-ui-badge">
          {{ getOverallUiState() | uppercase }}
        </div>

        <div class="overall-ui-details">
          <div class="overall-ui-message">
            {{ getOverallUiMessage() }}
          </div>

          <div class="overall-ui-subtext">
            {{ getOverallAffectedDevicesText() }}
          </div>
        </div>
      </div>
    </div>

  </div>

    <!-- Main Content - WITH SIDEBAR LAYOUT -->
    <div class="main-grid" *ngIf="floorPlanUrl">
      <!-- Canvas Area -->
      <div class="canvas-area">
        <div class="card">
          <div
            #canvasContainer
            class="canvas-container"
            (mousemove)="onMouseMove($event)"
            (mouseup)="onMouseUp()"
            (mouseleave)="onMouseUp()"
          >
            <div
              class="canvas-content"
              [style.transform]="'scale(' + zoom + ')'"
            >
              <img
                #floorImage
                [src]="floorPlanUrl"
                alt="Floor plan"
                class="floor-image"
                draggable="false"
                (load)="onImageLoad($event)"
              />

              <!-- Room boundaries (read-only); the hovered device's room is highlighted -->
              <app-room-boundary-layer
                *ngIf="isImageReady && rooms.length"
                [rooms]="rooms"
                [imageWidth]="originalImageWidth"
                [imageHeight]="originalImageHeight"
                [zoom]="zoom"
                [editable]="false"
                [highlightRoomId]="hoveredDevice?.floorRoomId ?? null"
              >
              </app-room-boundary-layer>

              <!-- Devices -->
              <ng-container *ngIf="isImageReady">
                <div
                  *ngFor="let device of devices; trackBy: trackByDeviceId"
                  class="device-marker"
                  role="button"
                  tabindex="0"
                  [attr.aria-label]="'Open device health for ' + (device.deviceName || device.macId)"
                  (click)="openDeviceHealth(device)"
                  (keydown.enter)="openDeviceHealth(device)"
                  [attr.data-sim-version]="simulationDisplayVersion"
                  [ngClass]="getDeviceTypeClass(device)"
                  [class.device-modified]="isDeviceModified(device.id)"
                  [style.left.px]="getDevicePosition(device).x"
                  [style.top.px]="getDevicePosition(device).y"
                  [style.--device-scale]="zoom"
                  [class.device-hidden]="isResizing"
                  (mousedown)="
                    can('drag')
                      ? onDeviceMouseDown($event, device.id)
                      : $event.preventDefault()
                  "
                  (mouseenter)="onDeviceMouseEnter(device)"
                  (mouseleave)="onDeviceMouseLeave()"
                  [class.device-disabled]="!can('drag')"
                  [ngbTooltip]="
                    !can('drag')
                      ? 'You do not have permission to perform this action'
                      : ''
                  "
                >
                  <svg
                    *ngIf="isZoomedOut"
                    class="device-dot"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="10" cy="10" r="8" />
                  </svg>

                  <svg
                    *ngIf="!isZoomedOut"
                    class="device-hexagon"
                    viewBox="0 0 100 100"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <polygon
                      points="50 5, 93.3 27.5, 93.3 72.5, 50 95, 6.7 72.5, 6.7 27.5"
                    />
                  </svg>
                  <span [class.device-disabled-tooltip]="!can('drag')"></span>

                  <div
                    class="modified-indicator"
                    *ngIf="isDeviceModified(device.id)"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="12"
                      height="12"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="3"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <circle cx="12" cy="12" r="10"></circle>
                    </svg>
                  </div>

                  <div
                    class="device-tooltip"
                    [class.device-tooltip-flip]="isTooltipFlipped(device)"
                    [class.device-tooltip-start]="getTooltipAlign(device) === 'start'"
                    [class.device-tooltip-end]="getTooltipAlign(device) === 'end'"
                    *ngIf="hoveredDevice?.id === device.id && can('drag')"
                    (click)="$event.stopPropagation()"
                    (mousedown)="$event.stopPropagation()"
                  >
                    <div class="tooltip-header">
                      <div class="tooltip-rows">
                        <div class="tooltip-row">
                          <strong>Device Name:</strong> {{ device.deviceName }}
                        </div>
                        <div class="tooltip-row">
                          <strong>Room:</strong> {{ device.roomName || 'Unassigned' }}
                        </div>
                        <div class="tooltip-row">
                          <strong>Alert:</strong> {{ getDeviceDisplayCategory(device) }}
                        </div>
                      </div>
                      <button
                        type="button"
                        class="device-delete"
                        (click)="openDeleteModal(device.id, $event)"
                        (mousedown)="$event.stopPropagation()"
                        [disabled]="!can('delete')"
                        [attr.title]="can('delete') ? 'Delete device' : 'No permission'"
                        aria-label="Delete device"
                      >
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                          <path d="M3 6h18"></path>
                          <path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                          <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6"></path>
                          <line x1="10" y1="11" x2="10" y2="17"></line>
                          <line x1="14" y1="11" x2="14" y2="17"></line>
                        </svg>
                      </button>
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>

          <!-- Legend -->
          <div class="legend">
            <div class="legend-title">Device Status</div>
            <div class="legend-items">
              <div class="legend-item">
                <div class="legend-indicator legend-fine"></div>
                <span>No Alert ({{ fineDevicesCount }})</span>
              </div>
              <div class="legend-item">
                <div class="legend-indicator legend-alert"></div>
                <span>Alert ({{ alertDevicesCount }})</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Sidebar -->
      <div class="sidebar">
        <!-- Alerts Section -->
        <div class="card alerts-card" *ngIf="floorPlanUrl">
          <h3 class="sidebar-title">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
            Device Alerts
            <span class="alerts-badge" *ngIf="alertBadgeCount > 0">{{
              alertBadgeCount
            }}</span>
          </h3>

          <div
            class="alerts-container"
            #alertsContainer
            (scroll)="onAlertsScroll($event)"
          >
            <p *ngIf="alertsLoading && alerts.length === 0" class="no-alerts">
              Loading alerts...
            </p>
            <p *ngIf="!alertsLoading && alerts.length === 0" class="no-alerts">
              No active alerts
            </p>

            <div
              *ngFor="let alert of alerts; trackBy: trackByAlertId; let i = index"
              class="alert-item me-2"
              [attr.data-sim-version]="simulationDisplayVersion"
              [ngClass]="'alert-' + getAlertDisplayClass(alert.category)"
            >
              <div class="alert-header">
                <div class="alert-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <circle cx="12" cy="12" r="10"></circle>
                    <line x1="12" y1="8" x2="12" y2="12"></line>
                    <line x1="12" y1="16" x2="12.01" y2="16"></line>
                  </svg>
                </div>
                <div class="alert-title">
                  <span
                    class="alert-category"
                    [style.color]="getAlertDisplayColor(alert.category)"
                    >{{ getAlertDisplayCategory(alert.category) }}</span
                  >
                </div>
              </div>

              <div class="alert-details">
                <div class="alert-detail-row">
                  <span class="alert-label">Floor:</span>
                  <span class="alert-value">{{ alert.floorName }}</span>
                </div>
                <div class="alert-detail-row">
                  <span class="alert-label">Status:</span>
                  <span class="alert-value">{{ alert.status }}</span>
                </div>
                <!-- <div class="alert-detail-row">
                  <span class="alert-label">MacId:</span>
                  <span class="alert-value">{{ alert.macId }}</span>
                </div> -->
              </div>

              <div class="alert-footer">
                <span class="alert-date">{{
                  getAlertDate(alert) | date: "MMM d, y, h:mm a"
                }}</span>
                <span class="alert-relative">{{
                  getRelativeTime(getAlertDate(alert))
                }}</span>
              </div>
              <!-- ACTION BUTTONS -->
              <div class="alert-actions mt-2">
                <!-- NOT ACKNOWLEDGED -->
                <button
                  *ngIf="alert.status === 'NotAcknowledged'"
                  class="alert-btn alert-btn--ack"
                  (click)="acknowledgeAlert(alert)"
                >
                  ✓ Acknowledge
                </button>

                <!-- ACKNOWLEDGED -->
                <button
                  *ngIf="alert.status === 'Acknowledged'"
                  class="alert-btn alert-btn--resolve"
                  (click)="resolveAlert(alert)"
                >
                  ✔ Resolve
                </button>
              </div>
            </div>

            <p *ngIf="alertsLoading && alerts.length > 0" class="alerts-loading">
              Loading more alerts...
            </p>
          </div>

          <button
            type="button"
            class="tap-top alerts-tap-top"
            *ngIf="showAlertsBackToTop"
            (click)="scrollAlertsToTop()"
            aria-label="Back to top"
            title="Back to top"
          >
            <app-feather-icon [icon]="'chevrons-up'"></app-feather-icon>
          </button>
        </div>
      </div>
    </div>
    <!-- Empty State -->
    <div class="empty-state-main" *ngIf="!floorPlanUrl">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="64"
        height="64"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
        <line x1="3" y1="9" x2="21" y2="9"></line>
        <line x1="9" y1="21" x2="9" y2="9"></line>
      </svg>
      <h3>No Floor Selected</h3>
      <p>Please select a facility and floor to view devices</p>
    </div>

</div>

<app-delete-modal
  #deleteModal
  (confirmdeletion)="confirmdelete($event)"
  [details]="'Device'"
></app-delete-modal>
